import React from "react";

export default function Notifications(props) {
    return (
        <ul className="pl-3 mb-0">
            {props.data?.map(
                (item, i) =>
                    props.notificationsFilter[item.type] && (
                        <li key={i} data-test-id="trip-planning-notification">
                            {item.name}
                        </li>
                    ),
            )}
        </ul>
    );
}
